// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10iEE","tabsBox":"styles_tabsBox__3nM4M","createButton":"styles_createButton__MLu_v"};